import styled from '@emotion/styled'
import { withClass } from 'common/emotion'
import { keyframes, CSSObject } from '@emotion/css'

import { breakpoint, calcRem } from 'component-library/__styling/style-functions'
import { colors } from 'component-library/__styling/settings'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { themedValue } from 'component-library/__styling/themed-value'

interface Keyframes {
    [key: string]: CSSObject
}
export interface StyledLiveLabelProps {
    isLarge?: boolean
}

const liveBlinkAnimation: Keyframes = {
    from: {
        opacity: 1,
    },
    to: {
        opacity: 0.1,
    },
}

export const styledLiveLabelClassName = 'LiveLabel'

export const StyledLiveLabel = withClass(styledLiveLabelClassName)(
    styled('span')<StyledLiveLabelProps>(
        {
            fontSize: calcRem(12),
            display: 'inline-block',
            textTransform: 'uppercase',
            fontWeight: 700,
            lineHeight: 1,

            '&::before': {
                content: `''`,
                display: 'inline-block',
                marginRight: calcRem(4),
                fontSize: calcRem(12),
                borderRadius: '100%',
                animation: `${keyframes(liveBlinkAnimation)} 1s infinite ease`,

                '@media (prefers-reduced-motion: reduce)': {
                    animation: 'none',
                },
            },
        },
        props => ({
            fontSize: props.isLarge ? calcRem(16) : calcRem(12),

            '&::before': {
                backgroundColor: themedValue(props.theme, {
                    thewest: section => section.primaryColor,
                    perthnow: colors.perthnow.redRuby,
                    fallback: 'currentColor',
                }),
                width: props.isLarge ? '1em' : '0.917em',
                height: props.isLarge ? '1em' : '0.917em',
                transform: !props.isLarge ? 'translateY(1px)' : undefined,
            },

            ...conditionalStyles(props.theme.kind === 'perthnow', {
                [breakpoint('xxs')]: {
                    marginRight: props.isLarge ? 0 : calcRem(10),
                },
            }),
        }),
        ({ theme }) => ({
            fontFamily: theme.fonts.sansSerif,
        })
    )
)
StyledLiveLabel.displayName = 'LiveLabel'
